// import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for DigitApp - WIP
const theme = mode => createTheme({
  palette: {
    mode,
    ud: {
      primary: {
        main: '#0E7693',
        text: '#fff'
      }  
    },
    tcp: {
      primary: {
        main: '#1f4a7c',
        text: '#fff'
      }  
    },
    awasbandhu: {
      primary: {
        main: '#364a65',
        text: '#fff',
      }  
    },
    primary: {
      main: '#556cd6',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: '#f00',
    },
    divider: "rgba(0, 0, 0, 0.25)",
    dull: {
      main: '#A9A9A9',
      light: '#D3D3D3',
      dark: '#808080',
      contrastText: '#fff',
    }
  },
  shape: {
    borderRadius: 6,
  },
  typography: {
    htmlFontSize: 18,
    fontFamily: '"Poppins", sans-serif',
    fontWeightSemiBold: 600,
    fontSize: 14,
  },
  overrides: {
    MuiButton: {
      root: {
        padding: '6px 16px',
        // borderRadius: 6,
        // padding: '',
      }
    }
  },
});

export default theme;
